import { axiosInstance } from '@/api/client';

export const getRestaurantHotActions = async (restaurant_id, router) => {
  const user = JSON.parse(localStorage.getItem('userObj')) ?? {};
  try {
    const response = await axiosInstance.get(
      `/admin/restaurant/${restaurant_id}/hot-actions/`,
      {
        headers: {
          Authorization: `Bearer ${user.access_token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      if (router) router.push('/admin/login');
    }
    throw error;
  }
};

export const updateRestaurantHotActions = async (restaurant_id, hot_actions, router) => {
  const user = JSON.parse(localStorage.getItem('userObj')) ?? {};
  try {
    const response = await axiosInstance.put(
      `/admin/restaurant/${restaurant_id}/hot-actions/`,
      { hot_actions },
      {
        headers: {
          Authorization: `Bearer ${user.access_token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      if (router) router.push('/admin/login');
    }
    throw error;
  }
};

// Hot Action Notifications API functions
export const getHotActionNotifications = async (restaurant_id, router) => {
  const user = JSON.parse(localStorage.getItem('userObj')) ?? {};
  try {
    const response = await axiosInstance.get(
      `/admin/restaurant/${restaurant_id}/hot-actions/notifications/`,
      {
        headers: {
          Authorization: `Bearer ${user.access_token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      if (router) router.push('/admin/login');
    }
    throw error;
  }
};

export const updateNotificationStatus = async (restaurant_id, notification_id, status, router) => {
  const user = JSON.parse(localStorage.getItem('userObj')) ?? {};
  try {
    const response = await axiosInstance.put(
      `/admin/restaurant/${restaurant_id}/hot-actions/notifications/${notification_id}/status/`,
      { status },
      {
        headers: {
          Authorization: `Bearer ${user.access_token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      if (router) router.push('/admin/login');
    }
    throw error;
  }
};

export const markAllNotificationsAsCompleted = async (restaurant_id, router) => {
  const user = JSON.parse(localStorage.getItem('userObj')) ?? {};
  try {
    const response = await axiosInstance.post(
      `/admin/restaurant/${restaurant_id}/hot-actions/mark-all-completed/`,
      {},
      {
        headers: {
          Authorization: `Bearer ${user.access_token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      if (router) router.push('/admin/login');
    }
    throw error;
  }
};
